import React from "react";

import CalciteSearch from "calcite-react/Search";

import QueryCriteria from "../../base/QueryCriteria";
import * as component from "../../../components/util/component";

export default class Search extends React.Component {

  constructor(props) {
    super(props);
    let inputValue = "";
    const queryCriteria = this.getQueryCriteria();
    if (queryCriteria) inputValue = queryCriteria.searchText
    this.state = component.newState({
      inputValue: inputValue
    });
    this.clearSearch = this.clearSearch.bind(this);
    this.onRequestClear = this.onRequestClear.bind(this);
    this.onUserAction = this.onUserAction.bind(this);
    this.searchChanged = this.searchChanged.bind(this);
  }

  clearSearch() {
    this.setState({
      inputValue: ""
    });
    this.onTextChange("");
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getQueryCriteria() {
    if (this.props.queryCriteriaKey) {
      return QueryCriteria.get(this.props.queryCriteriaKey);
    }
  }

  onRequestClear() {
    this.clearSearch();
  }

  onTextChange(text) {
    const queryCriteria = this.getQueryCriteria();
    if (queryCriteria) queryCriteria.onSearchTextChanged(text);
    if (this.props.searchTextChanged) this.props.searchTextChanged(text);
  }

  onUserAction(inputValue, selectedItemVal) {
    this.setState({
      inputValue: inputValue
    });
    if (inputValue === this.state.inputValue) {
      return;
    }
    this.onTextChange(inputValue);
  }

  render() {
    return (
      <CalciteSearch
        {...this.props}
        inputValue={this.state.inputValue}
        onChange={this.searchChanged}
        onRequestClear={this.onRequestClear}
        onUserAction={this.onUserAction}
        remote={true}
      />
    );
  }

  searchChanged(e) {
    // not applicable?
  }
}
